import { inject, NgModule } from "@angular/core";
import { ResolveFn, RouterModule, Routes } from "@angular/router";
import { AuthguardService } from "./services/authguard.service";
import { GroupService } from "./services/group.service";
import type { fhirR4 } from "@smile-cdr/fhirts";

export const GroupResolver: ResolveFn<fhirR4.Group[]> = () => {
  const groupService = inject(GroupService);
  return groupService.getGroups();
};

const routes: Routes = [
  { path: "", redirectTo: "orderlist", pathMatch: "full" },
  {
    path: "login",
    loadComponent: () =>
      import("./login/login.component").then((m) => m.LoginComponent),
  },
  {
    path: "error",
    loadComponent: () =>
      import("./error/error.component").then((m) => m.ErrorComponent),
  },
  {
    path: "orderlist",
    loadComponent: () =>
      import("./orderlist/orderlist.component").then(
        (m) => m.OrderlistComponent,
      ),
    canActivate: [AuthguardService],
  },
  {
    path: "orderdetail/:resourceType/:id",
    canActivate: [AuthguardService],
    loadComponent: () =>
      import("./orderdetail/orderdetail.component").then(
        (m) => m.OrderdetailComponent,
      ),
  },
  {
    path: "patientlist",
    loadComponent: () =>
      import("./patientlist/patientlist.component").then(
        (m) => m.PatientListComponent,
      ),
    canActivate: [AuthguardService],
  },
  {
    path: "provideraccess",
    loadComponent: () =>
      import("./provider-access/provider-access.component").then(
        (m) => m.ProviderAccessComponent,
      ),
    canActivate: [AuthguardService],
    resolve: { groups: GroupResolver },
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: "disabled",
      useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
